<template>
  <section class="py-12">
    <div class="container-wrap">
      <p class="text-sm font-bold text-gray-600">
        {{ tGlobal('products.section-name.learn-more') }}
      </p>
      <h2 class="text-h2 mb-6">
        {{ productLearnMore.sectionTitle }}
      </h2>

      <!-- Tabs -->
      <TheTabSelector
        v-model="currentIndex"
        :tabs="productRecommendProducts.map((item) => item.briefTabName)"
      />

      <!-- Selected item -->
      <LearnMoreCard v-if="currentItem" :item-data="currentItem" />
    </div>
  </section>
</template>

<script setup lang="ts">
  import type { IProductInfoLearnMoreItem } from '@/assets/types/api/Products';
  import LearnMoreCard from '@/components/Area/Products/LearnMoreCard.vue';

  const { t: tGlobal } = useI18n({ useScope: 'global' });

  const productsStore = useProductsStore();
  const { productLearnMore, productRecommendProducts } =
    storeToRefs(productsStore);

  const currentIndex = ref<number>(0);

  const currentItem = computed((): IProductInfoLearnMoreItem | null => {
    return productRecommendProducts.value[currentIndex.value] ?? null;
  });
</script>
